import { api } from 'app/config/apiConfig';
import { RentOptionDocument } from '../model/types';

export const createRentOptionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createRentOption: builder.mutation<RentOptionDocument, RentOptionDocument>({
      query: (data) => ({
        url: '/contracts/rent/rent-options',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Rent options'],
    }),
  }),
});

export const { useCreateRentOptionMutation } = createRentOptionApi;
